import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
import { Col } from 'react-bootstrap'
import { FaAsterisk } from "react-icons/fa";

const ItemProducto = ({ producto, executeScroll, tipo }) => {
    const { marca, descripcion, link } = producto;
    const { productos: { nodes: listadoImagenes } } = useStaticQuery(getImagenes);
    const marcaProducto = listadoImagenes.filter(img => img.producto.fluid.originalName === marca);
    const esContacto = link === "#contacto" ? true : false;

    const tipoCss = tipo.replace(' ', '-').toLowerCase();
    return (
        <Col sm={12} md={6} lg={5}>
            <div className={`caja-producto caja-${tipoCss}`}>
                <span>
                    <span>
                        <div >
                            <FaAsterisk size={10} className={`letra-${tipoCss}`} /> <span className="tipo-producto">{tipo}</span>
                        </div>
                        <div className="marca-producto">
                            <Image fluid={marcaProducto[0].producto.fluid} />
                        </div>
                        <p>
                            {
                                descripcion.split("\n").map((item, i) => {
                                    return (
                                        <span key={i}>
                                            {item}
                                            <br /><br />
                                        </span>
                                    )
                                })
                            }
                        </p>
                    </span>
                </span>
                <a href={link} target={link !== "#contacto" ? "_blank" : null} rel={link !== "#contacto" ? "noreferrer" : null}
                    {...(esContacto && { onClick: executeScroll })} className={`btn-visitar-producto btn-visitar-${tipoCss}`}>
                    VISITAR SITIO WEB
                </a>
            </div>

        </Col>

    )
}


export default ItemProducto

const getImagenes = graphql`
{
    productos:allFile(filter: {sourceInstanceName: {eq: "productos"}}) {
        nodes {
            producto:childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                    originalName
                }
            }
        }
    }
}
`